<template>
  <van-config-provider :theme="theme" :class="appConfig.getTemplateClass" :style="safeAreaHeight">
    <template v-if="
      appConfig.getTemplateClass == 'nantong' &&
      !['/login', '/register', '/feedBack', '/replyList']?.includes(route.path)
    ">
      <div v-if="isNanTong && ['/search', '/videoDetail']?.includes(route.path)" class="decorate orange z-[-1]"></div>
      <div v-if="isNanTong && ['/search', '/videoDetail']?.includes(route.path)" class="decorate yellow z-[-1]"></div>
      <div v-if="isNanTong && ['/search', '/videoDetail']?.includes(route.path)" class="decorate blue z-[-1]"></div>
      <div v-if="isNanTong && ['/search', '/videoDetail']?.includes(route.path)" class="decorate pink z-[-1]"></div>
      <div v-if="isNanTong && ['/search', '/videoDetail']?.includes(route.path)" class="decorate blue1 z-[-1]"></div>
      <div v-if="isNanTong && ['/search', '/videoDetail']?.includes(route.path)" class="decorate blue2 z-[-1]"></div>
    </template>
    <NuxtLayout>
      <ClientOnly>
        <AdDialogs v-if="globalStor.appData && showAd" />
        <NuxtPage v-if="globalStor.appData &&
          globalStor.jsonApi &&
          showFlag" :keepalive />

        <div :class="{ nantong: isNanTong }">
          <NantongDialog v-if="isNanTong" v-model:show="signinDialogStatus" @right-click="toLogin"
            @left-click="signinDialogStatus = false" title="登录提示" subTitle="请登录后再使用此功能" left-btn-text="取消"
            right-btn-text="立即登录" />
          <!-- 登录弹窗 -->
          <van-popup v-if="!isNanTong" class="login-popup-w"
            title=""
            :show="!!loginDialogStatus"
            :show-cancel-button="false"
            :showConfirmButton="false">
            <img :src="theme === 'light' ? collectLight : collectDark" />
            <div class="login-con-sub-title" :class="theme">
              请登录后再使用此功能
            </div>
            <div style="position: absolute;bottom: 100px;left:20%">
              <van-button color="#CECDCD"
                class="login-pop-btn-w"
                style="
                  --van-button-primary-border-color: #CECDCD;
                  --van-button-primary-background: #CECDCD;
                "
                plain type="primary"
                :style="{
                  '--van-button-primary-border-color': theme === 'light' ? '#303030' : '#CECDCD',
                  '--van-button-primary-background': theme === 'light' ? '#303030' : '#CECDCD',
                }" @click.stop="loginDialogStatus = 0">取消</van-button>
              <van-button
                class="login-pop-btn-w"
                style="margin-left: 1rem;
                background-color:#FFCB58;color: #000000;
                --van-button-primary-border-color: rgba(0,0,0,0);"
                type="primary" @click.stop="toLogin">立即登录</van-button>
            </div>
            <van-icon style="margin-top:24px;color:#ffffff" name="close" size="42px"
              @click.stop="loginDialogStatus = 0" />
          </van-popup>
        </div>

      </ClientOnly>
    </NuxtLayout>
  </van-config-provider>
  <ClientOnly>
    <NoticeDialog ref="noticeDialog" />
    <AppLoadding v-if="globalStor.appData" />
    <OverLimitTip />
  </ClientOnly>
</template>
<script lang="ts" setup>
import { watchHistoryList, collectionList } from '~/apis/user'
import collectLight from '~/assets/images/light/collectDialog.png'
import collectDark from '~/assets/images/dark/collectDialog.png'
import { initCaptcha } from './composables/useUtil'
import { PositionTypeEnum } from './types/enumTypes'
import { useHead, useLocalStore } from '#imports'
import { trackAppInstall } from './hooks/useAppInstall'
import { onMounted } from 'vue'
import { useTestStore } from '~/stores/testStore'
import { ThemeEnum } from '~/theme'
const route = useRoute()
const safeAreaHeight = ref({
  minHeight: '100vh',
  height: '110vh',
  background: 'transparent'
})
const globalStor: any = useGlobalStore()
const authStore = useAuthStore()
const recommendsStore: any = useRecommendsStore()
const bestStroe: any = useBestsStore()
const localStore: any = useLocalStore()
import DisableDevtool from 'disable-devtool';

const {
  theme,
  noticeDialog,
  userLoginedHistoryList,
  userLoginedCollectList,
  userLoginedHistoryIds,
  userLoginedCollectIds,
  appData,
  curAdvDomain,
  appConfig,
  clklog,
  currtClientApi,
  isNanTong,
  resetWrapperHeight,
}: any = storeToRefs(globalStor)
const iconData: any = computed(() => appData.value?.advList?.ICON_ADV?.[PositionTypeEnum.TOP]?.BANNER?.[0] || '')
const { isAuthenticated, loginDialogStatus } = storeToRefs(authStore)

// keepalive 所需的参数 指定name值为index 的页面 进行缓存
const keepalive = {
  include: ['homeIndex', 'index', 'videoPage', 'movieHot', 'movieBest', 'movieLatest', 'hotTag', 'movieStore', 'gayMovieBest', 'collect']
}

// 服务端处理
if (process.server) {
  const event = useRequestEvent()
  const headersDistinct = event?.req.headersDistinct
  const host = headersDistinct?.['host']?.[0] || 'localhost:3000'
  let domain

  const globalStor: any = useGlobalStore()

  // 判断是否是测试环境
  if (host.includes('dfre45.com') || host.includes('adre45.com')) {
    domain = `http://${host}`
    globalStor.isTest = true
  } else {
    domain = `https://${host}`
    globalStor.isTest = false
  }

  if (!globalStor.isDev) {
    globalStor.domain = domain as string
  }
  const {
    public: { custom }
  } = useRuntimeConfig()
  // console.log("运行时配置：",custom)
  globalStor.serverApi = custom.serverApi
  // globalStor.jsonApi = custom.jsonApi
  // console.log("获取json api:",globalStor.jsonApi)

  const configStore = useConfigStore()
  configStore.customConfig = custom

  // 在服务端设置响应状态和重定向
  const nuxtApp = useNuxtApp()
  nuxtApp.provide('test', 'test')
  const { data, error }: any = await useAsyncData('getAppConfigAction', () => globalStor.getAppConfigAction())
  // 在服务器端渲染期间处理错误并进行重定向
  if (data?.value?.success) {
    configStore.first.error = 'no error'
  } else {
    // console.log('this.refName:',getQueryParam('ref'))
    configStore.first.error = error.value
    configStore.first.error = 'error'
    //@ts-ignore
    nuxtApp.ssrContext?.res?.writeHead(302, { Location: '/error' })
    //@ts-ignore
    nuxtApp.ssrContext?.res?.end()
    //navigateTo('/error', { redirectCode: 404 });
  }
}

// 随机静态资源域名
let advIdx = 0
if (globalStor.assertApiList.length > 0) {
  advIdx = useRandom(0, globalStor.assertApiList.length - 1)
}
globalStor.currtAssertApi = globalStor.assertApiList[advIdx]
// console.log('随机静态资源域名:', globalStor.assertApiList,globalStor.curAdvDomain?.url)
const currtAssertApi = globalStor.currtAssertApi?.url || globalStor.domain

const config = useRuntimeConfig()
const version = config.public.version

useHead({
  bodyAttrs: {
    class: globalStor?.appConfig?.identifies,
    'data-t-id': globalStor.tenantId,
    'data-w-id': globalStor.webSiteId,
    'data-custom': currtAssertApi,
    'data-version': version
  },
  script: [
    {
      children: `window.addEventListener('load', () => {
        if('serviceWorker' in navigator) {
          navigator.serviceWorker.register('/sw.js').then(registration => {
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
          }).catch(err => {
            console.log('ServiceWorker registration failed: ', err);
          });
        }
      })`
    }
  ]
})
const signinDialogStatus = ref(false);

const router = useRouter()
const toLogin = () => {
  router.push('/login')
  loginDialogStatus.value = 0
}
watch(loginDialogStatus, (nv) => {
  if (nv) {
    if (isNanTong.value) {
      signinDialogStatus.value = true;
    }
  } else {
    signinDialogStatus.value = false;
  }
})

// 处理CNZZ脚本
const cnzz = appConfig?.value?.cnzz || ''
const cnzzWebId = appConfig?.value?.cnzzWebId || ''
let cnzzList = cnzz.split(',').map((item: string) => item.trim())
let cnzzWebIdList = ''
if (cnzzWebId) {
  cnzzWebIdList = cnzzWebId.split(',').map((item: string) => item.trim())
}
// 判断当前路由是不是 /
// const isHome = route.path === '/'

if (cnzzList.length > 0) {
  // 动态插入脚本
  useHead({
    script: cnzzList.map((scriptStr: any) => ({
      src: scriptStr,
      async: true,
      defer: true
    }))
  })
}
// 51LA脚本处理
const la51 = appConfig?.value?.la || ''
create51LaJs(la51)

const staticFrameList = [
  '/',
  '/search',
  '/user/gay/movieHot',
  '/user/gay/movieBest',
  '/user/gay/movieLatest',
  '/user/gay/hotTag',
  '/user/gay/movieStore',
  '/user/gay/movieRecord'
]
// 配置头部信息
if (process.client) {
  setTimeout(() => {
    setWrapperHeight(route);
  }, 1000)
  watch(route, (to, from) => {
    globalStor.prevRoutePath = from.fullPath;
    setWrapperHeight(to);
  })
  // 监听 iconData 变化 和 curAdvDomain 变化
  watch(
    [iconData, () => curAdvDomain?.value?.url],
    ([newVal, domainUrl]) => {
      const imgUrl = newVal?.imgUrl

      // 只有当 domainUrl 和 imgUrl 都存在时才设置头部信息
      if (domainUrl && imgUrl) {
        const fullIconUrl = getWebPImg(domainUrl + imgUrl)
        // console.log(fullIconUrl, 'icon');

        useHead({
          link: [{ rel: 'icon', href: fullIconUrl }],
          title: newVal.name,
          meta: [{ name: 'description', content: newVal.name }]
        })

        useSeoMeta({
          title: newVal.name,
          ogTitle: newVal.name,
          description: newVal.name,
          ogDescription: newVal.name
        })
      }
    },
    { immediate: true, deep: true }
  )

  // 设置默认的头部信息
  useHead({
    title: '',
    meta: [{ name: 'description', content: '' }],
    bodyAttrs: {
      class: `keep-px ${appConfig.value.getTemplateClass}`
    }
  })
}

const setWrapperHeight = (route: { path: string }) => {
  if (globalStor.isNanTong && staticFrameList?.includes(route?.path)) {
    let viewHeight = 0;
    if (window.visualViewport && window.visualViewport.height) {
      viewHeight = window.visualViewport.height + 70;
    }
    safeAreaHeight.value = {
      height: 'auto',
      minHeight: '100vh',
      background: 'linear-gradient(170deg, #FFF 6.3%, #D4D4E8 97.94%)'
    }
  } else {
    safeAreaHeight.value = {
      height: 'auto',
      minHeight: '100vh',
      background: 'transparent'
    }
  }
}

const showFlag = ref(false)

function SWclear() {
  const newTime: any = document.getElementsByTagName('body')?.[0]?.getAttribute('data-version')
  const localTime = localStorage.getItem('time')
  if (!localTime) {
    return localStorage.setItem('time', newTime)
  }
  if (newTime != localTime) {
    if ('serviceWorker' in navigator) {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'CLEAR_CACHE'
        })
      }
    }
  }
}

// 版本检测
const versionCheckFun = async () => {
  const isHttps = window.location.protocol === "https:";
  if (!globalStor.isDev && isHttps) {
    await VersionUtils.checkAndHandle({
      onUnavailable: async () => {
        console.error('域名不可用，跳转到错误页面')
        window.location.href = "/restrict.html"
      },
      onNeedsRefresh: () => {
        console.info('检测到新版本，即将刷新页面')
        // TODO 删除缓存的版本内容
        window.location.reload()
      },
      onAvailable: async () => {
        console.log('域名检测通过，继续正常流程')
        // deleteBucket('html-cache')
        // deleteBucket('static-cache')
        await deleteBucket('json-cache')
        // await deleteFileFromBucket('html-cache', '/')
        // await deleteNuxtResourcesFromStaticCache()
        cacheFiles()
      }
    })
  }
}
function getVconsole() {
  if (import.meta.client && location.search.includes('debug=1')) {
    const script = document.createElement('script')
    script.src = 'https://unpkg.com/vconsole/dist/vconsole.min.js'
    script.onload = () => new window.VConsole();
    document.body.appendChild(script)
  }
}
getVconsole();

onMounted(async () => {
  if (process.client) {
    document.documentElement.style.backgroundColor = "#0e0e10";
    window.testError = () => {
      const bbb: any = {};
      bbb[Math.random()]();
    }
    try {
      const config = useRuntimeConfig()
      const version = config.public.version
      window.appVersion = version;
      console.log('版本号：', version)
      console.log(noticeDialog.value);

      // 获取body的 data-t-id="3" data-w-id="3" 设置给 globalStor.tenantId 和 globalStor.webSiteId
      const domTenantId = document.querySelector('body')?.getAttribute('data-t-id')
      const domWebSiteId = document.querySelector('body')?.getAttribute('data-w-id')
      // 如果globalStor.tenantId 和 globalStor.webSiteId和body的data-t-id和data-w-id不一致，重新设置
      if (domTenantId && globalStor.tenantId != domTenantId) {
        globalStor.tenantId = domTenantId
      }
      if (domWebSiteId && globalStor.webSiteId != domWebSiteId) {
        globalStor.webSiteId = domWebSiteId
      }
      //await useConfigInfo()
      localStore.startCountdown()

      if (globalStor?.appConfig?.webSiteId) {
        await globalStor.getAppConfigWebAction()
        await globalStor.getHomeJsonAction()
        showFlag.value = true
      }

      if (globalStor.isNanTong) {
        globalStor.setThemeClass(ThemeEnum.light)
        globalStor.theme = ThemeEnum.light
      } else {
        globalStor.setThemeClass()
      }

      // 检测是否来自 webclip.html
      // globalStor.setThemeClass()

      // 初始化主题
      // globalStor.setThemeClass()
      // globalStor.setThemeClass('dark')
      bestStroe?.getData()
      recommendsStore?.getData()

      // 随机广告域名
      const advIdx = useRandom(0, globalStor.advDomainList.length - 1)
      globalStor.curAdvDomain = globalStor.advDomainList[advIdx]
      // 随机视频域名
      // const rIdx = useRandom(0, globalStor.routeList.length - 1)
      // globalStor.curResourceDomain = globalStor.routeList[rIdx]
      //最快域名
      globalStor.curResourceDomain = await measureDomainSpeed(globalStor.routeList, '/domain.js')
      console.log('[域名调试] app.vue 初始化 curResourceDomain:', {
        selected: globalStor.curResourceDomain?.url,
        routeList: globalStor.routeList.map((r: any) => r?.url)
      })
      // 视随机频封面域名
      const videoImageRdm = useRandom(0, globalStor.videoImageList.length - 1)
      // console.log('videoImageRdm',videoImageRdm)
      globalStor.curVideoImageDomain = globalStor.videoImageList[videoImageRdm]

      //@ts-ignore
      const cIdx = useRandom(0, globalStor.clientApiList.length - 1)
      globalStor.currtClientApi = globalStor.clientApiList[cIdx]?.url || window.location.origin
      //console.log('随机客户端域名:', globalStor.currtClientApi)

      // 随机静态资源域名
      let astIdx = 0
      if (globalStor.assertApiList.length > 0) {
        astIdx = useRandom(0, globalStor.assertApiList.length - 1)
      }
      globalStor.currtAssertApi = globalStor.assertApiList[astIdx]

      // console.log('随机资源域名:', globalStor?.currtAssertApi?.url)
      // 设置全局变量
      window.currtAssertApi = globalStor?.currtAssertApi?.url || window.location.origin

      initCaptcha()
    } catch (error) {
      console.error('Error in getHomeJsonAction:', error)
    } finally {
      setTimeout(() => {
        versionCheckFun();
      }, 1200)
    }
    //发布后 清除sericeWork
    // SWclear()
  }
})

// 客户端渲染
if (process.client) {
  // clklog打点统计
  const clklogFun = async (config: { url: any; project: any; token: any }) => {
    // console.log('window.currtAssertApi:', window.currtAssertApi)
    if (config?.url && config?.project && config.token) {
      window.clklog = config
      window.appConfigCopy = appConfig.value
      window.originDomain = window.location.origin
      // 打点统计script加载
      useHead({
        script: [
          {
            src: `${window.currtAssertApi}/clklog/autotrack.js?t=${new Date().getTime()}`,
            async: true
          }
        ]
      })
      setTimeout(() => {
        trackAppInstall()
        const params = route.query?.key
        if (params === 'diversion') {
          // console.log('导航页跳转，上报事件！')
          trackEvent({ type: 'clklog', category: 'DomainVisit' })
        }
      }, 1400)
    }
  }

  // 监听clklog变化
  watch(clklog, (newVal) => {
    if (newVal) {
      clklogFun(newVal)
    }
  })
  watch(
    [() => currtClientApi.value, () => isAuthenticated.value],
    ([newVal, authen]) => {
      if (newVal && authen) {
        getHistoryCollect()
      }
    },
    {
      immediate: true,
      deep: true
    }
  )

  function getHistoryCollect() {
    if (!isAuthenticated.value) {
      return
    }
    watchHistoryList({
      current: 1,
      size: 500
    }).then((res: any) => {
      userLoginedHistoryList.value = []
      userLoginedHistoryIds.value = []
      let { records } = res.data
      userLoginedHistoryList.value = records
      for (let i = 0; i < records.length; i++) {
        userLoginedHistoryIds.value.push(records[i].videoId)
      }
    })

    collectionList({
      current: 1,
      size: 500
    }).then((res: any) => {
      userLoginedCollectList.value = []
      userLoginedCollectIds.value = []
      let { records } = res.data
      for (let i = 0; i < records.length; i++) {
        userLoginedCollectIds.value.push(records[i].videoId)
        records[i].id = records[i].videoId
      }
      userLoginedCollectList.value = records
    })
  }
}

const buildDodyCnzz = () => {
  createCnzzJs('https://img.9918xt.com/html/1/tk.js')
}

const testStore = useTestStore()
onMounted(() => {
  if(!SafeUtil.getParam('player')){
    if(!import.meta.env.DEV && !location.href?.includes('test.')){
      DisableDevtool({ timeOutUrl: '' })
    }
  }
  if (document.referrer && document.referrer.includes('webclip.html')) {
    // 重载页面
    window.location.reload()
  }
  // console.log('版本号：1.0.7',$version)
  const config = useRuntimeConfig()
  const version = config.public.version
  console.log('版本号：', version)
  window.addEventListener('beforeunload', function () {
    // 触发自定义事件，记录页面关闭行为
    trackEvent({ category: 'PageClose' })
  })
  console.log('testStore:', testStore.version)
  testStore.version = version
  // 将 globalStor 赋值到 window 对象上
  window.globalStor = globalStor.$state
  buildDodyCnzz();

  resetWrapperHeight.value = setWrapperHeight;
})

const showAd = computed(() => {
  if (import.meta.dev) {
    if (sessionStorage.getItem('show-ad-status')) {
      return false;
    }
  }
  return true;
})

const cacheFiles = () => {
  if (!globalStor.isDev) {
    setTimeout(async () => {
      // 缓存所有文件
      const result = await proactiveCacheAll({
        onProgress: (current, total, fileName) => {
          console.log(`缓存进度: ${current}/${total} - ${fileName}`)
        },
        onError: (error, fileName) => {
          console.error(`缓存失败: ${fileName}`, error)
        }
      })
      console.log('所有文件已缓存:', result)
    }, 6000)
  }
}

async function deleteBucket(bucketName: string): Promise<boolean> {
  try {
    const deleted = await caches.delete(bucketName);

    if (deleted) {
      console.log(`成功删除桶: "${bucketName}"`);
    } else {
      console.log(`未找到桶: "${bucketName}"`);
    }

    return deleted;
  } catch (error) {
    console.error(`删除桶时出错`);
    return false;
  }
}

</script>

<style lang="scss">
html,
body {
  overflow: visible;
  -webkit-overflow-scrolling: touch;
}

body {
  position: relative;
}
/* 移动端：最大宽度 750px */
@media screen and (max-width: 750px) {
  .keep-px {
    max-width: 750px;
  }
}

/* PC端：固定宽度 375px 居中 */
@media screen and (min-width: 751px) {
  .keep-px {
    width: 375px;
    max-width: 375px;
  }
}
.login-popup-w{
  width:343px;
  --van-popup-background: rgba(0,0,0,0);text-align: center;
  --van-popup-close-icon-z-index: 99999;
}
.login-pop-btn-w{
  height:40px;
  width:90px;
  border-radius: 16px;
}
.van-image__error,
.van-image__loading {
  background-color: #242b34;

  img {
    object-fit: cover;
  }
}



.login-con-sub-title {
  width: 284px;
  position: absolute;
  top: 212px;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size:21px;
  font-weight: 400;
  background: linear-gradient(#241904, #1d1304);

  &.light {
    background: linear-gradient(#fce3bf, #fce9ce);
    color: #2b2b2b;
  }
}

.nantong {

  .van-image__error,
  .van-image__loading {
    background: none !important;
  }
}

.previewDialog {
  background-color: transparent !important;
  height: 100% !important;
  left: 0 !important;
  max-width: none !important;
  position: fixed !important;
  top: 0 !important;
  transform: none !important;
  width: 100% !important;

  .van-image-preview__close-icon {
    position: absolute !important;
    font-size: var(--van-image-preview-close-icon-size) !important;
  }
}

.nantong {
  .van-toast {
    padding: 10px 15px;
    border-radius: 5px;
    background: #000;
    color: #fff !important;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    border: unset !important;
    width: fit-content !important;
    height: auto !important;
    box-sizing: unset !important;
  }

  // background-color: white;
  .form-container {
    background: linear-gradient(170deg, #fff 6.3%, #d4d4e8 97.94%) !important;
  }

  .van-nav-bar__content {
    background-color: unset !important;
  }

  :deep(.van-nav-bar) {
    background: unset !important;
    background-color: unset !important;
  }
}

.nantongLogOutDialog {
  border-radius: 14px;
  background: linear-gradient(170deg, #fff 6.3%, #d4d4e8 97.94%);
  width: 300px;

  .van-dialog__header {
    color: #000 !important;
    padding: 0;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 130px;
    height: 130px;
    flex-shrink: 0;
  }

  .van-dialog__footer {
    justify-content: space-between;
    padding: 0 20px;
    margin-bottom: 30px;
  }

  .van-dialog__cancel {
    min-width: 116px !important;
    max-width: 116px !important;
    height: 30px;
    // padding: 6px 29px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 5px;
    background: #000;
  }

  .van-dialog__confirm {
    display: flex;
    min-width: 116px !important;
    max-width: 116px !important;
    height: 30px;
    padding: 6px 29px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 5px;
    background: #7a51ed !important;
    color: #fff !important;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }
}
</style>
